import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card shadow-none mb-0" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row center-all" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col-auto ps-0" }
const _hoisted_6 = {
  key: 0,
  class: "fas fa-check-circle text-primary"
}
const _hoisted_7 = {
  key: 1,
  class: "far fa-circle opacity-25 text-muted"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSelectionItem',
  props: {
    selected: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.selected)
            ? (_openBlock(), _createElementBlock("i", _hoisted_6))
            : (_openBlock(), _createElementBlock("i", _hoisted_7))
        ])
      ])
    ])
  ]))
}
}

})